<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	export let parentMarket;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;
	let errors;

	let parentMarketForm = {
		name: parentMarket.name
	};

	function updateParentMarket() {
		if (parentMarket.is_manual === false) {
			return;
		}
		sending = true;
		parentMarket
			.patch(parentMarketForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Parent market successfully updated',
					message: `${parentMarket.name} successfully updated!`,
					timeout: 3
				});
				dispatch('updated');
				open = false;
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem updating parent market',
					timeout: 3
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Update parent market - {parentMarket.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Name"
				name="marketTypeName"
				className="py-4 w-full text-left"
				required={true}
				errors={errors && errors.name}
				disabled={!parentMarket.is_manual}
				placeholder="Enter market type name"
				bind:value={parentMarketForm.name}
			/>
			<LoadingButton on:click={() => updateParentMarket()} loading={sending} className="my-4 btn btn-primary">
				{sending ? 'Updating' : 'Update'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
